<template>
	<div class="route-bar">
		<div class="route-bar-breadcrumb">
			<ul>
				<li  ><button class="p-link" @click="home"><i class="pi pi-home"></i></button></li>
				
				<template v-for="(path) of $route.path.split('/')" >
				   
					<li v-bind:key="path" v-if="path" >/ {{path}}</li>
					
					
				</template>
			</ul>
		</div>
	
	</div>
</template>

<script>
	export default {
		methods: {
			home() {
				window.location = "/#/home"
			}
		}
	}
</script>

<style scoped>

</style>